// @todo - look these up from css vars?
export const greens = {
  COLOR2: '#197C51',
  COLOR4: '#6EC19C',
  COLOR1: '#105A3A',
  COLOR5: '#A4D8C2',
  COLOR3: '#4AB284',
  COLOR6: '#D1ECE0',
  COLOR7: '#08311F',
  COLOR8: '#668176',
},
             blues = {
               COLOR2: '#0565A1',
               COLOR5: '#9BC1D9',
               COLOR1: '#013556',
               COLOR4: '#69A2C6',
               COLOR3: '#3783B3',
               COLOR6: '#CDE0EC',
               COLOR7: '#4AA2D1',
               COLOR8: '#819AB4',
             },
             purples = {
               COLOR2: '#3F0E40',
               COLOR4: '#8B6E8C',
               COLOR1: '#250726',
               COLOR5: '#B29EB2',
               COLOR3: '#653E66',
               COLOR6: '#D8CED9',
               COLOR7: '#381839',
               COLOR8: '#675A67',
             },
             reds = {
               COLOR2: '#A8412C',
               COLOR4: '#CB8D80',
               COLOR1: '#813323',
               COLOR5: '#DCB3AA',
               COLOR3: '#B96756',
               COLOR6: '#EED9D4',
               COLOR7: '#E8947D',
               COLOR8: '#CCA9A1',
             },
             oranges = {
               COLOR2: '#CB7538',
               COLOR4: '#E0AC87',
               COLOR1: '#965426',
               COLOR5: '#EAC8AF',
               COLOR3: '#D5905F',
               COLOR6: '#F5E3D7',
               COLOR7: '#F8A366',
               COLOR8: '#D3B6A1',
             },
             grays = {
               COLOR1: '#f8f9fa',
               COLOR2: '#e9ecef',
               COLOR3: '#dee2e6',
               COLOR4: '#ced4da',
               COLOR5: '#adb5bd',
               COLOR6: '#6c757d',
               COLOR7: '#495057',
               COLOR8: '#343a40',
               COLOR9: '#212529',
             },
             base = {
               forest: '#01563E',
               plants: '#1A8758',
               fresh: '#0565A1',
               water: '#004467',
               garden: '#3F0E40',
               harvest: '#A8412C',
               sun: '#CB7538',
               crops: '#C18C00',
             };
